import React, { useEffect, useState, useRef, useImperativeHandle, forwardRef, useCallback } from 'react';
import './style.scss'
import collection from '../../../assets/record/collection.png'
import collection_finish from '../../../assets/record/collection_finish.png'
import contrast from '../../../assets/record/contrast.png'
import contrast_finish from '../../../assets/record/contrast_finish.png'
import extract from '../../../assets/record/extract.png'
import extract_finish from '../../../assets/record/extract_finish.png'
import handle from '../../../assets/record/handle.png'
import handle_finish from '../../../assets/record/handle_finish.png'
import { useSelector } from "react-redux";
import { Button, Spin, Modal, message, Select } from 'antd';
import Recorder from 'recorder-core';
import SiriWave from "siriwave";
import { microphoneTip } from '../record/index'
import useBluetooth from '../../../hooks/useBluetooth';
import {
    getSpeakerVerify,
    getExtensionLimitSettings
} from "../../../utils";

import { getBlocksURL } from '../../../utils/utils'
import {
    ExclamationCircleFilled,
    CloseCircleFilled
} from '@ant-design/icons';

import '../wave'
const _progressList = [
    {
        init: collection,
        finish: collection_finish,
        label: '声音数据采集',
        name: 'collection',
        state: 'init'
    },
    {
        init: handle,
        finish: handle_finish,
        label: '声音预处理',
        name: 'handle',
        state: 'init'
    },
    {
        init: extract,
        finish: extract_finish,
        label: '声音特征提取',
        name: 'extract',
        state: 'init'
    },
    {
        init: contrast,
        finish: contrast_finish,
        label: '特征比对',
        name: 'contrast',
        state: 'init'
    }
]
let ctx = new (window.AudioContext || window.webkitAudioContext)();
let analyser = ctx.createAnalyser();
analyser.connect(ctx.destination);
analyser.fftSize = 2048;
let siriWave = null
let utimer = null
let blocksStream = null
let blockInput = null
let rec = null
let start = false;

const blocksRecord = forwardRef((props, ref) => {
    const name = props.name
    const state = useSelector(state => state.speaker);
    const bluetooth = state.bluetooth;
    const blocksWaveMask = useRef()
    const hasScore = useRef()
    const blocksWaveContainer = useRef()
    const [recordingVisible, setRecordingVisible] = useState(false);
    const [recordTime, setRecordTime] = useState(5);
    const [blocksTime, setBlocksTime] = useState(0);
    const [limitInfo, setLimitInfo] = useState({
        extension_id: '',
        one_day_limit: 0,
        any_minutes: 0,
        any_minutes_limit: 0,
        remain_nums: 0,
        can_use: true,
        next_use_time: '',
    })
    const [verifyResult, setVerifyResult] = useState({
        result: {},
        extra_result: {},
        success: false
    })
    const blocksFile = useRef(null)
    // 未开始、开始、结束、处理
    const [blocksRecordState, setBlocksRecordState] = useState('no_start')
    const [progressList, setProgressList] = useState(_progressList)
    const [afterRecordState, setAfterRecordState] = useState({
        title: '',
        desc: ''
    })
    const { sendMessage } = useBluetooth();
    const microphoneCheck = (success) => {
        return new Promise((resolve, reject) => {
            navigator.getUserMedia = navigator.getUserMedia ||
                navigator.webkitGetUserMedia ||
                navigator.mozGetUserMedia ||
                navigator.msGetUserMedia;
            navigator.getUserMedia({ audio: true }, async (stream) => {
                try {
                    resolve(stream)
                } catch (error) {
                    reject(error)
                }
            }, (error) => {
                rec && rec.close();
                message.error('缺少麦克风权限，请开启后再录制')
                reject('microphone_no_open')
            });
        })
    }
    const recOpen = (success) => {
        //打开麦克风授权获得相关资源
        return new Promise((resolve, reject) => {
            rec = Recorder({
                type: "wav",
                sampleRate: 16000,
                biteRate: 36,
                audioTrackSet: {
                    echoCancellation: true,
                    noiseSuppression: true,
                    autoGainControl: true
                },
                onProcess: function (buffers, powerLevel, bufferDuration, bufferSampleRate) {
                    siriWave.setAmplitude(powerLevel / 40);
                },
                
            })
            rec.open(function () {
                success && success();
                resolve('麦克风打开成功')
            }, function (msg, isUserNotAllow) {//用户拒绝未授权或不支持
                console.log((isUserNotAllow ? "UserNotAllow，" : "") + "无法录音:" + msg);
                reject('用户拒绝未授权或不支持')
            });
        })
    }
    const closeMicrophone = () => {
        start = false
        blockInput && blockInput.disconnect()
        console.log('utimer', utimer);
        if (utimer) {
            clearInterval(utimer)
            utimer = null
        }
        if (rec && rec.state !== 0) {
            rec.stop(async (blob, duration) => {
                blocksFile.current = new File([blob], "record.wav", { type: "audio/wav" });
                const url = (window.URL || window.webkitURL).createObjectURL(blob);
                console.log('下载链接',url)
            })
            rec.close()
        }
        // 关闭麦克风
        if (blocksStream) {
            console.log('关闭麦克风');
            const tracks = blocksStream.getTracks(); // 获取所有轨道
            tracks.forEach(track => track.stop()); // 停止每个轨道
            blocksStream = null; // 可选：清除对流的引用
        }
        siriWave && siriWave.stop()
    }

    const openRecord = () => {
        getExtensionLimit()
        setRecordingVisible(true)
    }
    const initProgressList = () =>{
        setProgressList(pre => {
            pre.forEach(f => {
                f.state = 'init'
            })
            return pre
        })
    }
    const closeRecord = () => {
        setRecordingVisible(false)
        setVerifyResult({
            result: {},
            extra_result: {},
            success: false
        })
        setRecordTime(5)
        setBlocksTime(0)
        initProgressList()
        siriWave && siriWave.dispose()
        closeMicrophone()
    }
    const startBlocksRecord = async () => {
        if (start) {
            return;
        }
        start = true
        initProgressList()
        setVerifyResult({
            result: {},
            extra_result: {},
            success: false
        })
        microphoneCheck().then(async (stream) => {
            blocksStream = stream
            const blocksRecordFn = () => {
                setProgressList(pre => {
                    pre[0].state = 'processing'
                    return pre
                })
                setBlocksTime(0)
                console.log('开始录制--');
                setBlocksRecordState('started')
                rec.start();
                siriWave && siriWave.dispose()
                siriWave = new SiriWave({
                    container: document.getElementById("blocks_wave_id"),
                    width: 460,
                    autostart: true,
                    amplitude: 1,
                    curveDefinition: [
                        { attenuation: -2, lineWidth: 1, opacity: 1, color: " 51, 51, 51" },
                        { attenuation: -6, lineWidth: 1, opacity: 1, color: " 51, 51, 51" },
                        { attenuation: 4, lineWidth: 1, opacity: 1, color: " 51, 51, 51" },
                        { attenuation: 2, lineWidth: 1, opacity: 1, color: " 51, 51, 51" },
                        { attenuation: 1, lineWidth: 1, opacity: 1, color: " 51, 51, 51" },
                    ]
                });
                siriWave.start()
                blockInput = ctx.createMediaStreamSource(stream);
                blockInput.connect(analyser);
                let second = recordTime;
                utimer = setInterval(() => {
                    second--;
                    setBlocksTime((pre) => pre + 1)
                    if (second == 0) {
                        closeMicrophone()
                        setTimeout(() => {
                            // 开始声纹验证
                            setBlocksRecordState('processing')
                            setProgressList(pre => {
                                pre[0].state = 'finish'
                                pre[1].state = 'processing'
                                return pre
                            })
                            const formData = new FormData();
                            formData.append('step', '1');
                            formData.append('content', '123456');
                            formData.append('extension_id', 'speakerRecognition');
                            formData.append('platform', 'lab');
                            formData.append('project_id', 0);
                            formData.append('file', blocksFile.current);
                            let retry = false;
                            const startSpeakerVerify = () => {
                                getSpeakerVerify(formData).then(res => {
                                    if (!res && !retry) {
                                        console.log('网络问题，重试一次');
                                        retry = true
                                        startSpeakerVerify()
                                        return
                                    } else {
                                        setBlocksRecordState('over')
                                        // errCode 2005 模型不存在  2012 用户名不合法
                                        if (res?.result?.errCode === 2005 || res.result?.errCode === 2012 || res?.code === 540000) {
                                            setProgressList(pre => {
                                                pre[1].state = 'error'
                                                return pre
                                            })
                                            setAfterRecordState({
                                                title: '声纹模型意外丢失',
                                                desc: "请<span class='close_modal'>关闭弹窗</span>，返回重新录入声纹模型作为参照物。<br>如连续重复出现此情况，请联系产品经理。"
                                            })
                                            return
                                        }
                                        // ret 700 验证失败  900 验证检测失败
                                        if (res?.result?.ret === 700 || res.result?.ret === 900) {
                                            setProgressList(pre => {
                                                pre[1].state = 'warning'
                                                return pre
                                            })
                                            setAfterRecordState({
                                                title: '辨认失败',
                                                desc: "请重试。需在较安静的环境中，保持正常语速，普通话发音。"
                                            })
                                            return
                                        }
                                        if (res?.result?.errCode || JSON.stringify(res.result) === '{}') {
                                            setProgressList(pre => {
                                                pre[1].state = 'error'
                                                return pre
                                            })
                                            setAfterRecordState({
                                                title: '错误',
                                                desc: "你的网络存在问题或缺少该功能的使用权限。请稍后再试，或联系实验室管理员。"
                                            })
                                            return
                                        }
                                        setProgressList(pre => {
                                            pre.forEach(f => f.state = 'finish')
                                            return pre
                                        })
                                        setAfterRecordState({
                                            title: '',
                                            desc: ''
                                        })
                                        getExtensionLimit()
                                        if (res.result.score) {
                                            if (res.result.score < 0) {
                                                res.result.score = 0
                                            }
                                            const similarity = Math.round(res.result.score * 100)
                                            res.result.score = similarity
                                            bluetooth && sendMessage({ similarity })
                                        }
                                        setVerifyResult(res)
                                    }
                                }).catch(err => {
                                    console.log('err', err);
                                })
                            }
                            startSpeakerVerify()
                        }, 100);
                    }
                }, 1000);
            }
            recOpen(blocksRecordFn)
        }).catch(err => {
            console.log('未授权', err);
        })
    }
    const stopBlocksRecord = () => {
        siriWave.dispose()
        setBlocksRecordState('no_start')
        initProgressList()
        setVerifyResult({
            result: {},
            extra_result: {},
            success: false
        })
        setBlocksTime(0)
        closeMicrophone()
        blocksFile.current = null
    }
    const changeTimeSelect = (val) => {
        setRecordTime(val)
        setBlocksTime(0)
        setVerifyResult({
            result: {},
            extra_result: {},
            success: false
        })
        initProgressList()
        if (!limitInfo.can_use) {
            setProgressList(pre => {
                pre[0].state = 'warning'
                return pre
            })
        }
    }
    const getExtensionLimit = async () => {
        try {
            let res = await getExtensionLimitSettings('speakerRecognition')
            setLimitInfo(res)
            setBlocksRecordState('no_start')
            if (!res.can_use && !hasScore.current) {
                setProgressList(pre => {
                    pre[0].state = 'warning'
                    return pre
                })
            }
        } catch (error) {
            console.log('error', error);
        }
    }
    const recordAgain = () => {
        setBlocksTime(0)
        setBlocksRecordState('no_start')
        siriWave && siriWave.dispose()
        initProgressList()
    }
    useEffect(() => {
        if (verifyResult.result.score) {
            hasScore.current = true
        } else {
            hasScore.current = false
        }
    }, [verifyResult])
    useImperativeHandle(ref, () => ({
        openRecord
    }));
    useEffect(() => {
        if (afterRecordState.desc.includes('close_modal')) {
            const button = document.querySelector('.close_modal');
            if (button) {
                button.addEventListener('click', closeRecord);
            }
        }
    }, [afterRecordState])
    
    useEffect(() => {
        if(!bluetooth){
            closeRecord()
        }
        
    }, [bluetooth])

    return (
        <Modal destroyOnClose={true} title={<span className='modal-title'>实验 {name === 'upload' && <span className='upload_tip'> 暂时仅支持现场录音实验</span>}</span>} className='record_modal' centered open={recordingVisible} width={660} onCancel={closeRecord} footer={<div className='record_footer'>
            <span>当前账户每 {limitInfo.any_minutes} 分钟可实验 {limitInfo.any_minutes_limit} 次，今日总共还可实验 {limitInfo.remain_nums} 次。</span>
            <Button type="primary" href={`${getBlocksURL()}`} target="_blank">打开硬件编程平台</Button>
        </div>}>
            <div className='progress_modal'>
                <div className='progress'>
                    {
                        progressList.map((m, index) =>
                            // 初始化、正在加载、完成、警告、报错
                            <div className='progress_item' key={index}>
                                <div className='progress_info'>
                                    {
                                        m.state == 'processing' ? <div className='processing'>
                                            <Spin size='large' style={{ width: '72px' }} />
                                        </div> :
                                            m.state == 'warning' ? <ExclamationCircleFilled className='state_icon' style={{ color: "#FAAD14" }} /> :
                                                m.state == 'error' ? <CloseCircleFilled className='state_icon' style={{ color: "#FF4D4F" }} /> : <img src={m.state == 'init' ? m.init : m.finish} alt="" />
                                    }
                                    <div className='label'>{m.label}</div>
                                </div>
                                {index !== 3 && <img className="arrow icon" alt="" src={
                                    m.state == 'finish' ? "/image/speaker/arrow-black.png" : "/image/speaker/arrow-grey.png"
                                } />}

                            </div>
                        )
                    }
                </div>
                {
                    blocksRecordState == 'over' ?
                        <div className='over center'>
                            <div className='title'>{afterRecordState.title}</div>
                            <div className='desc' dangerouslySetInnerHTML={{ __html: afterRecordState.desc }}></div>
                            <Button type="primary" ghost onClick={recordAgain}>返回重试</Button>
                        </div> :
                        <>
                            <div className='model_wave'>
                                <div className="wave_mask" id="blocks_wave_id" ref={blocksWaveMask}>
                                    <div className='line' style={{
                                        opacity: (blocksRecordState == 'no_start' || blocksRecordState == 'over') ? 1 : 0
                                    }}></div>
                                </div>
                                <span className='time'>{blocksTime} / {recordTime}</span>
                            </div>
                            <div className='record_state'>
                                {
                                    blocksRecordState == 'no_start' ?
                                        <>
                                            <div className='tip'>
                                                {microphoneTip('left')}
                                                <span>请允许浏览器调用麦克风（microphone），否则无法录制。</span>
                                            </div>
                                            <div className='time_select'>
                                                <Select
                                                    defaultValue={recordTime}
                                                    value={recordTime}
                                                    style={{ width: 88, marginRight: 16 }}
                                                    onChange={changeTimeSelect}
                                                    options={[
                                                        {
                                                            value: 5,
                                                            label: '5 秒',
                                                        },
                                                        {
                                                            value: 7,
                                                            label: '7 秒',
                                                        },
                                                        {
                                                            value: 10,
                                                            label: '10 秒',
                                                        },
                                                        {
                                                            value: 15,
                                                            label: '15 秒',
                                                        },
                                                    ]}
                                                />
                                                <Button type="primary" disabled={!!limitInfo.next_use_time} onClick={startBlocksRecord}>开始录制</Button>
                                            </div>
                                            {
                                                (typeof verifyResult.result.score ===  'number' || !limitInfo.can_use) && <div className='center'>
                                                    <p className='limit'>
                                                        {
                                                            typeof verifyResult.result.score ===  'number' ? `特征匹配结果相似度为 ${verifyResult.result.score}% ` : !limitInfo.can_use ? '使用频率或当日使用量已达到上限' : null
                                                        }
                                                    </p>
                                                    {limitInfo.next_use_time && <p className='next_time'>下一次录制需等到 {limitInfo.next_use_time}</p>}
                                                </div>
                                            }
                                        </> :
                                        blocksRecordState == 'started' ? <div className='center'>
                                            <Button type="primary" danger onClick={stopBlocksRecord}>停止录制</Button>
                                        </div> :
                                            blocksRecordState == 'processing' ? <div className='center'><Button type="primary" danger disabled={true}>处理中…</Button></div> : null
                                }
                            </div>
                        </>
                }
            </div>
        </Modal>
    )

})

export default blocksRecord;